export const fetchTransactions = async (apiUrl, token) => {
  const response = await fetch(apiUrl, {
    headers: { 
      Authorization: `Bearer ${token}`, 
      Accept: "application/json" 
    },
  });
  
  if (!response.ok) {
    throw new Error("Error al obtener datos del servidor");
  }
  
  const apiData = await response.json();
  return apiData.transactions || [];
};